exports = module.exports = require("../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".cell-placeholder{text-align:center;font-size:14px;margin-top:16px;font-weight:400;color:#91969d}.sidebar-helptext{font-size:14px;font-weight:400;color:#c6c6c6;margin:0}.scroll::-webkit-scrollbar{width:4px}.scroll::-webkit-scrollbar-track{background:#c6c6c6}.scroll::-webkit-scrollbar-thumb{background:#91969d;border-radius:4px}.scroll::-webkit-scrollbar-thumb:hover{background:#767c85}.ui-icon{cursor:inherit;display:inline-block;font-size:1.5rem;height:1em;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;vertical-align:middle;width:1em}.ui-icon svg{fill:currentColor;height:1em;margin:0;padding:0;width:1em}", ""]);

// exports
